export default "__VITE_ASSET__C9rS1$pB__"